export default __webpack_public_path__ + "static/media/gesilSampaio.d040f952.jpeg";